module.exports = __webpack_public_path__ + "img/myDibblingIcon.8138b143.svg";